import { foldAccents, foldForSearch } from "./search.js";
/**
 * THE SHOP'S ADDRESS (spec 2026-09-26, la tienda del negocio §3.1): made
 * from the business's name by the server, never typed by the owner, and
 * never changed afterwards -- the owner is told so when it is made.
 */
/** The migration's own check, spelled for the clients and the Worker. */
const SHOP_SLUG_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;
const SHOP_SLUG_MAX = 48;
/** Room for a «-2»…«-9999999» suffix under SHOP_SLUG_MAX. */
const BASE_MAX = 40;
const FALLBACK = "tienda";
/** Words a slug may not be: `/t/api/…` is the Worker's data door. */
export const RESERVED_SHOP_SLUGS = ["api"];
export function isShopSlug(raw) {
    return raw !== undefined && raw.length >= 3 && raw.length <= SHOP_SLUG_MAX && SHOP_SLUG_PATTERN.test(raw);
}
/**
 * «Panadería La Niña» → `panaderia-la-nina`. The app's own fold first (the
 * one search uses), then any other mark NFD can split off; everything that
 * is not a letter or a digit separates words. Cut at a word boundary; a name
 * with fewer than three usable characters (emojis, «Bo») is `tienda`.
 */
export function shopSlugOf(name) {
    const words = foldAccents(foldForSearch(name))
        .split(/[^a-z0-9]+/)
        .filter(Boolean);
    let slug = "";
    for (const word of words) {
        const next = slug === "" ? word : `${slug}-${word}`;
        if (next.length > BASE_MAX) {
            if (slug === "")
                slug = word.slice(0, BASE_MAX);
            break;
        }
        slug = next;
    }
    return slug.length < 3 ? FALLBACK : slug;
}
/** The base, else `base-2`, `base-3`… -- the first one not taken and not reserved. */
export function firstFreeSlug(base, taken) {
    const busy = new Set([...taken, ...RESERVED_SHOP_SLUGS]);
    if (!busy.has(base))
        return base;
    for (let attempt = 2;; attempt += 1) {
        const candidate = `${base}-${String(attempt)}`;
        if (!busy.has(candidate))
            return candidate;
    }
}
/**
 * The profile's title (spec 2026-10-20 §8): «Frío Total · Taller o servicio
 * técnico en Bella Vista, Panamá»; without trade or zone, those parts drop.
 * One function for the Worker's `<title>` and the page's own, which Google
 * reads once it has run the page: two spellings would leave it the bare name.
 */
export function profileTitle(shop) {
    const { trade, zone } = shop.profile;
    const what = trade !== null && zone !== null ? `${trade} en ${zone}` : (trade ?? zone);
    return what === null ? shop.business.name : `${shop.business.name} · ${what}`;
}
/**
 * How much of an item's long description a card carries: more than two lines
 * of the narrowest card, so the cut never shows, and a page of fifty stays
 * light. The whole text is on the item's own page.
 */
export const SHOP_CARD_DESCRIPTION_MAX = 160;
